import { DISPATCH_BRAND_CONSENT_CONFIG } from '../../actions/authentication/actionType';
import {
  API_ERROR_RESPONSE,
  BEGIN_AJAX_CALL,
  DISPATCH_CONTEXTUAL_HOME,
  DISPATCH_SURFACE,
  END_AJAX_CALL,
  FETCH_BRAND_RESOURCES,
  FETCH_MASTER_DATA,
  FETCH_OUTLET_DETAILS,
  FETCH_APP_STARTUP_INFO,
  MERGE_APP_STARTUP_INFO,
  DISPATCH_BRAND_RESOURCES,
  FETCH_BRAND_CITIES,
  DISPATCH_APPLICABLE_BRAND_MODULES,
  DISPATCH_GUEST_LOCATION,
  DISPATCH_COMMUNITY_CONTEXT,
  DISPATCH_APP_RESOLUTION_CONTEXT,
  CLEAR_APP_RESOLUTION_CONTEXT,
  DISPATCH_GUEST_COUPON_AND_DEAL_DATA,
  DISPATCH_STATIC_CONTEXT,
  FETCH_SOCIAL_MEDIA_CAMPAIGN_DETAILS,
  CLEAR_SOCIAL_MEDIA_CAMPAIGN_DETAILS,
  DISPATCH_LOGIN_REQUIRED_BEFORE_ORDERING,
  FETCH_NEARBY_OUTLET_DETAILS,
  DISPATCH_THEME_DATA,
  DISPATCH_ENTRY_CHANNEL,
  DISPATCH_ORDERING_AUTH_IN_PROGRESS,
  FETCH_BRAND_CONFIG_RESOURCE,
} from '../../actions/common/actionType';

const parseZoneConfig = (config) => {
  if (typeof config === 'string') {
    try {
      return JSON.parse(config) || {};
    } catch (error) {
      return {};
    }
  }
  return config || {};
};

const common = (state = {}, action = {}) => {
  if (action.type === BEGIN_AJAX_CALL) {
    const { showSpinner } = action;
    return {
      ...state,
      showSpinner,
    };
  } else if (action.type === END_AJAX_CALL) {
    const { showSpinner } = action;
    return {
      ...state,
      showSpinner,
    };
  } else if (action.type === API_ERROR_RESPONSE) {
    const { errorResponse } = action;
    return {
      ...state,
      errorResponse,
    };
  } else if (action.type === FETCH_MASTER_DATA) {
    const { masterData } = action;
    return {
      ...state,
      masterData,
    };
  } else if (action.type === FETCH_BRAND_RESOURCES) {
    const { resources } = action;
    return {
      ...state,
      resources,
    };
  } else if (action.type === FETCH_OUTLET_DETAILS) {
    const { outletDetails } = action;
    return {
      ...state,
      outletDetails,
    };
  }
  else if (action.type === FETCH_NEARBY_OUTLET_DETAILS) {
    const { nearbyOutlets } = action;
    return {
      ...state,
      nearbyOutlets,
    };
  } else if (action.type === DISPATCH_CONTEXTUAL_HOME) {
    const { contextualHome } = action;
    return {
      ...state,
      contextualHome,
    };
  } else if (action.type === DISPATCH_SURFACE) {
    const { surface } = action;
    return {
      ...state,
      surface,
    };
  } else if (action.type === FETCH_APP_STARTUP_INFO) {
    const { appStartupInfo } = action;
    return {
      ...state,
      appStartupInfo,
    };
  } else if (action.type === MERGE_APP_STARTUP_INFO) {
    const { appStartupInfo } = action;
    return {
      ...state,
      appStartupInfo: { ...state.appStartupInfo, ...appStartupInfo },
    };
  } else if (action.type === DISPATCH_BRAND_RESOURCES) {
    const { brandResources } = action;
    return {
      ...state,
      resources: brandResources,
    };
  } else if (action.type === FETCH_BRAND_CITIES) {
    const { brandCities } = action;
    return {
      ...state,
      brandCities,
    };
  } else if (action.type === DISPATCH_APPLICABLE_BRAND_MODULES) {
    const { modules } = action;
    return {
      ...state,
      modules,
    };
  } else if (action.type === DISPATCH_THEME_DATA) {
    const { themeData } = action;
    return {
      ...state,
      themeData,
    };
  } else if (action.type === DISPATCH_GUEST_LOCATION) {
    const { guestLocation } = action;
    return {
      ...state,
      guestLocation,
    };
  } else if (action.type === DISPATCH_COMMUNITY_CONTEXT) {
    const { communityContext } = action;
    const prev = state.communityContext || {};
    const incoming = communityContext || {};
    const next = {
      ...prev,
      ...incoming,
    };
    // Explicit `community` key: empty/null replaces (store switch); otherwise deep-merge zoneConfig.
    if (Object.prototype.hasOwnProperty.call(incoming, 'community')) {
      const nextCommunity = incoming.community;
      const hasCommunityId =
        nextCommunity &&
        typeof nextCommunity === 'object' &&
        (nextCommunity.id || nextCommunity.zoneId);
      if (!hasCommunityId) {
        next.community = {};
      } else {
        const prevCommunity = prev.community || {};
        next.community = {
          ...prevCommunity,
          ...nextCommunity,
          zoneConfig: {
            ...parseZoneConfig(prevCommunity.zoneConfig),
            ...parseZoneConfig(nextCommunity.zoneConfig),
          },
        };
      }
    }
    return {
      ...state,
      communityContext: next,
    };
  } else if (action.type === DISPATCH_APP_RESOLUTION_CONTEXT) {
    const { appResolutionContext } = action;
    return {
      ...state,
      appResolutionContext,
    };
  } else if (action.type === DISPATCH_GUEST_COUPON_AND_DEAL_DATA) {
    const { guestCouponAndDealData } = action;
    return {
      ...state,
      guestCouponAndDealData,
    };
  } else if (action.type === DISPATCH_STATIC_CONTEXT) {
    const { staticContext } = action;
    return {
      ...state,
      staticContext,
    };
  } else if (action.type === FETCH_SOCIAL_MEDIA_CAMPAIGN_DETAILS) {
    const { socialMediaCampaignDetails } = action;
    return {
      ...state,
      socialMediaCampaignDetails,
    };
  } else if (action.type === CLEAR_SOCIAL_MEDIA_CAMPAIGN_DETAILS) {
    const { socialMediaCampaignDetails } = action;
    return {
      ...state,
      socialMediaCampaignDetails,
    };
  } else if (action.type === DISPATCH_ENTRY_CHANNEL) {
    const { entryChannel } = action;
    return {
      ...state,
      entryChannel,
    };
  } else if (action.type === DISPATCH_BRAND_CONSENT_CONFIG) {
    const { brandConsentConfig } = action;
    return {
      ...state,
      brandConsentConfig,
    };
  } else if (action.type === DISPATCH_ORDERING_AUTH_IN_PROGRESS) {
    const { orderingAuthInProgress } = action;
    return {
      ...state,
      orderingAuthInProgress,
    };
  } else if (action.type === FETCH_BRAND_CONFIG_RESOURCE) {
    const { brandConfigResource } = action;
    return {
      ...state,
      brandConfigResource,
    };
  }
  return state;
};

export default common;
